import { Divider, FormControl, MenuItem, Select } from '@material-ui/core';
import { cloneDeep, get, isEmpty, map, omit, values } from 'lodash';
import React, { useContext, useEffect, useState } from 'react';

import { SectionType } from '../../../../DynamicInvoiceGenerator/InvoiceGenerator';
import SectionField from '../../../../DynamicInvoiceGenerator/models/SectionField';
import { InvoiceContext } from '../../../context/InvoiceContext';
import useDebounce from '../../../shared/use-debounce';
import sectionUtils from '../../../utils/sectionUtils';
import { EditableHeader } from '../../EditableHeader/EditableHeader';
import InputField from '../../InputField/InputField';
import classes from './MiscInfo.module.scss';

const selectOptionLabelMap: { [key: string]: string } = {
  textArea: 'text area',
  link: 'link'
};

const getSelectOptionIcon = (opt: string) => {
  const iconMap = {
    [selectOptionLabelMap.textArea]: (
      <svg
        width="25"
        height="22"
        viewBox="0 0 25 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.64358 2.75C2.64358 2.15326 2.88064 1.58097 3.30259 1.15901C3.72455 0.737053 4.29685 0.5 4.89358 0.5H19.8936C20.4903 0.5 21.0626 0.737053 21.4846 1.15901C21.9065 1.58097 22.1436 2.15326 22.1436 2.75V8.0945C22.7882 8.26025 23.3594 8.63567 23.7673 9.16167C24.1752 9.68768 24.3965 10.3344 24.3965 11C24.3965 11.6656 24.1752 12.3123 23.7673 12.8383C23.3594 13.3643 22.7882 13.7398 22.1436 13.9055V19.25C22.1436 19.8467 21.9065 20.419 21.4846 20.841C21.0626 21.2629 20.4903 21.5 19.8936 21.5H4.89358C4.29685 21.5 3.72455 21.2629 3.30259 20.841C2.88064 20.419 2.64358 19.8467 2.64358 19.25V13.9055C1.99894 13.7398 1.42772 13.3643 1.01985 12.8383C0.611983 12.3123 0.390625 11.6656 0.390625 11C0.390625 10.3344 0.611983 9.68768 1.01985 9.16167C1.42772 8.63567 1.99894 8.26025 2.64358 8.0945V2.75ZM4.14358 8.0945C4.78823 8.26025 5.35945 8.63567 5.76732 9.16167C6.17519 9.68768 6.39654 10.3344 6.39654 11C6.39654 11.6656 6.17519 12.3123 5.76732 12.8383C5.35945 13.3643 4.78823 13.7398 4.14358 13.9055V19.25C4.14358 19.4489 4.2226 19.6397 4.36325 19.7803C4.50391 19.921 4.69467 20 4.89358 20H19.8936C20.0925 20 20.2833 19.921 20.4239 19.7803C20.5646 19.6397 20.6436 19.4489 20.6436 19.25V13.9055C19.9989 13.7398 19.4277 13.3643 19.0199 12.8383C18.612 12.3123 18.3906 11.6656 18.3906 11C18.3906 10.3344 18.612 9.68768 19.0199 9.16167C19.4277 8.63567 19.9989 8.26025 20.6436 8.0945V2.75C20.6436 2.55109 20.5646 2.36032 20.4239 2.21967C20.2833 2.07902 20.0925 2 19.8936 2H4.89358C4.69467 2 4.50391 2.07902 4.36325 2.21967C4.2226 2.36032 4.14358 2.55109 4.14358 2.75V8.0945ZM3.39358 9.5C2.99576 9.5 2.61423 9.65804 2.33292 9.93934C2.05162 10.2206 1.89358 10.6022 1.89358 11C1.89358 11.3978 2.05162 11.7794 2.33292 12.0607C2.61423 12.342 2.99576 12.5 3.39358 12.5C3.79141 12.5 4.17294 12.342 4.45424 12.0607C4.73555 11.7794 4.89358 11.3978 4.89358 11C4.89358 10.6022 4.73555 10.2206 4.45424 9.93934C4.17294 9.65804 3.79141 9.5 3.39358 9.5ZM21.3936 9.5C20.9958 9.5 20.6142 9.65804 20.3329 9.93934C20.0516 10.2206 19.8936 10.6022 19.8936 11C19.8936 11.3978 20.0516 11.7794 20.3329 12.0607C20.6142 12.342 20.9958 12.5 21.3936 12.5C21.7914 12.5 22.1729 12.342 22.4542 12.0607C22.7355 11.7794 22.8936 11.3978 22.8936 11C22.8936 10.6022 22.7355 10.2206 22.4542 9.93934C22.1729 9.65804 21.7914 9.5 21.3936 9.5Z"
          fill="#333333"
        />
        <path
          d="M17.5446 5H7.24255L7.14355 7.991H7.72255C8.03755 6.113 8.64055 5.822 10.9821 5.7485L11.4966 5.732V15.2465C11.4966 16.052 11.3226 16.244 9.92305 16.3685V17H14.8641V16.3685C13.4571 16.244 13.2831 16.0535 13.2831 15.2465V5.732L13.8051 5.747C16.1451 5.822 16.7496 6.113 17.0646 7.991H17.6436L17.5446 5Z"
          fill="#333333"
        />
      </svg>
    ),
    [selectOptionLabelMap.link]: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.07242 9.813L5.01442 11.871C4.17043 12.715 3.69629 13.8597 3.69629 15.0532C3.69629 16.2468 4.17043 17.3915 5.01442 18.2355C5.85841 19.0795 7.00309 19.5536 8.19667 19.5536C9.39025 19.5536 10.5349 19.0795 11.3789 18.2355L14.1209 15.492C14.6299 14.983 15.0093 14.3593 15.2273 13.6733C15.4453 12.9873 15.4956 12.259 15.374 11.5496C15.2523 10.8402 14.9622 10.1702 14.5281 9.59611C14.0939 9.02197 13.5284 8.56035 12.8789 8.25L11.9999 9.129C11.9107 9.2184 11.8331 9.31869 11.7689 9.4275C12.2707 9.57175 12.7262 9.84447 13.0903 10.2187C13.4544 10.5929 13.7145 11.0557 13.8449 11.5612C13.9754 12.0668 13.9716 12.5976 13.834 13.1013C13.6964 13.6049 13.4298 14.064 13.0604 14.433L10.3199 17.175C9.757 17.7379 8.99351 18.0542 8.19742 18.0542C7.40133 18.0542 6.63784 17.7379 6.07492 17.175C5.512 16.6121 5.19575 15.8486 5.19575 15.0525C5.19575 14.2564 5.512 13.4929 6.07492 12.93L7.26442 11.742C7.09659 11.1131 7.03175 10.4611 7.07242 9.8115V9.813Z"
          fill="#333333"
        />
        <path
          d="M9.87883 7.00935C9.36989 7.51836 8.99048 8.14204 8.77244 8.82803C8.55441 9.51402 8.50412 10.2423 8.62579 10.9517C8.74746 11.6612 9.03754 12.3311 9.47168 12.9052C9.90583 13.4794 10.4714 13.941 11.1208 14.2513L12.2833 13.0873C11.7748 12.9509 11.311 12.6831 10.9388 12.3107C10.5665 11.9382 10.2988 11.4744 10.1626 10.9658C10.0264 10.4571 10.0265 9.92162 10.1628 9.41302C10.2992 8.90442 10.567 8.44066 10.9393 8.06835L13.6798 5.32635C14.2428 4.76343 15.0062 4.44718 15.8023 4.44718C16.5984 4.44718 17.3619 4.76343 17.9248 5.32635C18.4878 5.88927 18.804 6.65276 18.804 7.44885C18.804 8.24494 18.4878 9.00843 17.9248 9.57135L16.7353 10.7593C16.9033 11.3893 16.9678 12.0418 16.9273 12.6898L18.9853 10.6318C19.8293 9.78786 20.3035 8.64317 20.3035 7.4496C20.3035 6.25602 19.8293 5.11134 18.9853 4.26735C18.1413 3.42336 16.9967 2.94922 15.8031 2.94922C14.6095 2.94922 13.4648 3.42336 12.6208 4.26735L9.87883 7.00935Z"
          fill="#333333"
        />
      </svg>
    )
  };
  const OptionIcon = iconMap[opt];
  return OptionIcon;
};

function getLabel(type: string, key: string, fieldLabel: string) {
  const map = {
    html_content: {
      value: `Enter the ${fieldLabel || 'field value'} in html content`
    },
    [selectOptionLabelMap.link]: {
      value: `Enter the ${fieldLabel || 'link'} placeholder`,
      getter: `Enter the ${fieldLabel || 'link'} url`,
      label: `Enter the label for the ${fieldLabel || 'link'}`
    }
  };
  const field = get(map, type, {});
  const label = get(field, key, '');
  return label;
}

function getChangeField(type: string): object {
  const map = {
    [selectOptionLabelMap.textArea]: { value: '' },
    [selectOptionLabelMap.link]: { value: '', getter: '', label: '' }
  } as { [key: string]: object };

  const changeFields = map[type] ?? { value: '' };
  return changeFields;
}

const type = SectionType.MISC_INFO;
const MiscInfo: React.FC = () => {
  const invoiceContext = useContext(InvoiceContext);
  const { heading, fields } = invoiceContext.getConfig(type);
  const initialState = sectionUtils.getInitialValuesByIndex(fields);
  const [inputFields, setInputFields] = useState(initialState);
  const debouncedFields = useDebounce(inputFields, 100);
  const [addKey, setAddKey] = useState('');

  const [selectedOption, setSelectedOption] = useState(
    selectOptionLabelMap.textArea
  );

  const handleAddField = () => {
    if (isEmpty(addKey)) {
      return window.alert('Key must Not Be Empty');
    }
    function getSelectOptType(opt: string) {
      const map = {
        [selectOptionLabelMap.textArea]: 'html_content',
        [selectOptionLabelMap.link]: 'link'
      } as { [key: string]: string };
      return map[opt];
    }

    const newFieldIdx = (Object.keys(inputFields || {}).length + 1).toString();
    const newField = new SectionField({
      id: newFieldIdx,
      label: addKey,
      getter: '',
      value: '',
      req: true,
      type: getSelectOptType(selectedOption)
    });
    setInputFields(prev => ({ ...prev, [newFieldIdx]: newField }));
    return setAddKey('');
  };

  // const handleDeleteField = () => {
  //   const idxToDelete = Object.keys(inputFields || {}).length;
  //   idxToDelete > 0
  //     ? setInputFields(prev => omit(prev, idxToDelete.toString()))
  //     : setInputFields({});
  // };

  useEffect(
    () => invoiceContext.setConfig(type, inputFields),
    // eslint-disable-next-line
    [debouncedFields]
  );

  const DeleteBin = ({ handleDeleteField }: any) => {
    return (
      <div
        onClick={() => handleDeleteField()}
        style={{
          marginLeft: 'auto',
          cursor: 'pointer'
        }}
      >
        <svg
          width="19"
          height="20"
          viewBox="0 0 19 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.36461 3.91453V4.14864H11.1104V3.91453C11.1104 3.41781 10.9131 2.94143 10.5618 2.5902C10.2106 2.23897 9.73421 2.04164 9.2375 2.04164C8.74078 2.04164 8.2644 2.23897 7.91317 2.5902C7.56193 2.94143 7.36461 3.41781 7.36461 3.91453ZM6.19406 4.14864V3.91453C6.19406 3.10736 6.51471 2.33325 7.08546 1.76249C7.65622 1.19174 8.43033 0.871094 9.2375 0.871094C10.0447 0.871094 10.8188 1.19174 11.3895 1.76249C11.9603 2.33325 12.2809 3.10736 12.2809 3.91453V4.14864H17.5484C17.7036 4.14864 17.8525 4.2103 17.9623 4.32006C18.072 4.42982 18.1337 4.57869 18.1337 4.73391C18.1337 4.88914 18.072 5.038 17.9623 5.14776C17.8525 5.25752 17.7036 5.31919 17.5484 5.31919H16.1826L15.2462 16.489C15.175 17.3373 14.7878 18.1278 14.1612 18.704C13.5347 19.2802 12.7145 19.6 11.8633 19.5999H6.61172C5.76058 19.5998 4.94053 19.28 4.31407 18.7039C3.6876 18.1277 3.30043 17.3372 3.22929 16.489L2.29285 5.31919H0.926584C0.771359 5.31919 0.622492 5.25752 0.512732 5.14776C0.402971 5.038 0.341309 4.88914 0.341309 4.73391C0.341309 4.57869 0.402971 4.42982 0.512732 4.32006C0.622492 4.2103 0.771359 4.14864 0.926584 4.14864H6.19406ZM4.39563 16.3912C4.44224 16.9469 4.6959 17.4648 5.10634 17.8423C5.51679 18.2198 6.05407 18.4293 6.61172 18.4294H11.8633C12.421 18.4294 12.9584 18.22 13.3689 17.8424C13.7795 17.4649 14.0332 16.947 14.0798 16.3912L15.0078 5.31919H3.46715L4.39563 16.3912ZM8.06694 8.47967C8.06694 8.40281 8.05181 8.32671 8.02239 8.2557C7.99298 8.18469 7.94987 8.12017 7.89552 8.06582C7.84117 8.01147 7.77665 7.96836 7.70564 7.93895C7.63463 7.90954 7.55853 7.8944 7.48167 7.8944C7.40481 7.8944 7.3287 7.90954 7.25769 7.93895C7.18669 7.96836 7.12216 8.01147 7.06782 8.06582C7.01347 8.12017 6.97036 8.18469 6.94094 8.2557C6.91153 8.32671 6.89639 8.40281 6.89639 8.47967V15.2689C6.89639 15.3457 6.91153 15.4218 6.94094 15.4928C6.97036 15.5639 7.01347 15.6284 7.06782 15.6827C7.12216 15.7371 7.18669 15.7802 7.25769 15.8096C7.3287 15.839 7.40481 15.8541 7.48167 15.8541C7.55853 15.8541 7.63463 15.839 7.70564 15.8096C7.77665 15.7802 7.84117 15.7371 7.89552 15.6827C7.94987 15.6284 7.99298 15.5639 8.02239 15.4928C8.05181 15.4218 8.06694 15.3457 8.06694 15.2689V8.47967ZM10.9933 7.8944C11.3164 7.8944 11.5786 8.1566 11.5786 8.47967V15.2689C11.5786 15.4241 11.5169 15.573 11.4072 15.6827C11.2974 15.7925 11.1485 15.8541 10.9933 15.8541C10.8381 15.8541 10.6892 15.7925 10.5795 15.6827C10.4697 15.573 10.408 15.4241 10.408 15.2689V8.47967C10.408 8.1566 10.6702 7.8944 10.9933 7.8944Z"
            fill="#606367"
          />
        </svg>
      </div>
    );
  };

  function renderField(field: SectionField, idx: number) {
    const { type, id, label } = field;
    const changeFields = getChangeField(type);

    const getHandler = (id: string) => (e: any) => {
      const { name, value } = e.target;
      setInputFields(prev => ({
        ...prev,
        [id]: {
          ...inputFields[id],
          [name]: value
        }
      }));
    };

    return (
      <div className={classes.fieldGroups}>
        {Object.entries(changeFields).map(([fieldName]) => {
          const inputFieldProps = {
            key: id,
            onChange: getHandler(id!),
            name: fieldName,
            label: getLabel(type, fieldName, label),
            defaultValue: get(field, fieldName, ''),
            type: type
          };
          return <InputField {...inputFieldProps} />;
        })}
        <DeleteBin
          handleDeleteField={() =>
            setInputFields(prev => omit(cloneDeep(prev), id.toString()))
          }
        />
      </div>
    );
  }

  function renderForm() {
    return <form className={classes.form}>{map(fields, renderField)}</form>;
  }

  const renderAddField = () => {
    return (
      <>
        <div className={classes.labelInput}>
          <InputField
            type="text"
            label="Enter Field Name"
            name="addKey"
            value={addKey}
            defaultValue={addKey}
            placeholder={'Enter The Field Name'}
            onChange={e => setAddKey(e.target.value)}
            style={{
              boxShadow: '0px 0px 5px rgba(210, 210, 210, 0.25)',
              backgroundColor: '#F8F9FA',
              padding: '0.5em'
            }}
          />
          <FormControl className={classes.formControl}>
            <Select
              value={selectedOption}
              onChange={e => setSelectedOption(e.target.value as string)}
              variant="outlined"
              className={classes.select}
            >
              {values(selectOptionLabelMap).map((option, idx) => (
                <MenuItem value={option} key={idx}>
                  <div className={classes.menuItem}>
                    <span className={classes.icon}>
                      {getSelectOptionIcon(option)}
                    </span>
                    <span>{option}</span>
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <Divider />
        <div className={classes.actionGroup}>
          <p style={{ marginRight: 'auto' }}>
            Field name is considered as label
          </p>
          <div className={classes.btns}>
            <button onClick={handleAddField} className={classes.btn}>
              add
            </button>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className={classes.container}>
      <EditableHeader
        content={heading}
        handleChange={headerVal => invoiceContext.updateHeader(type, headerVal)}
      />
      {renderForm()}
      <div className={classes.addField}>{renderAddField()}</div>
    </div>
  );
};

export default MiscInfo;
